import React, { useState, useEffect } from "react";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { observer } from "mobx-react-lite";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { runInAction } from "mobx";
import { InvoiceFields } from "../InvoiceFields/InvoiceFields";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import EventLabel from "../../components/EventLabel";

const PaymentOptions = (props) => {
  const [showInvoiceFields, setShowInvoiceFields] = useState(false);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const { settings, addOrUpdate, activePersonNo, orders, updateOrder, current, contentModuleId, validations, checkHeights } = props;

  useEffect(() => {
    configureOptions();
  }, []);

  useEffect(() => {
    configureOptions();
  }, [settings.paymentMethods]);

  const configureOptions = () => {
    if (settings.paymentMethods.length > 1 && selectedOption != "invoice") {
      setShowPaymentOptions(true);
    } else if (settings && settings.paymentMethods && settings.paymentMethods.length === 1 && settings.paymentMethods.includes("invoice")) {
      setShowInvoiceFields(true);
      runInAction(() => {
        current.payMethod = "invoice";
      });
    } else if (settings && settings.paymentMethods && settings.paymentMethods.length === 1 && settings.paymentMethods.includes("dibs")) {
      setShowInvoiceFields(false);
      runInAction(() => {
        current.payMethod = "dibs";
      });
    }
  };

  useEffect(() => {
    checkHeights();
  }, [current.payMethod]);

  const expand = (option) => {
    const module = props.contentLayout.contentLayoutModules.find((clm) => clm.contentLayoutModuleId == props.contentLayoutModuleId);
    const validity = validations.find((v) => v.id == contentModuleId);

    if (!module) return;

    runInAction(() => {
      current.payMethod = option;
      validity.valid = true;
    });
  };

  if (settings.hidden) return null;
  if (settings.paymentMethods.length == 1 && showInvoiceFields == true) {
    return (
      <div style={{ display: "block", width: "100%" }}>
        <InvoiceFields {...props} />
      </div>
    );
  } else if (settings.paymentMethods.length > 1) {
    return (
      <div style={{ display: "block", width: "100%" }}>
        <FormControl component="fieldset">
          <label style={{ textAlign: "left" }}>
            <EventLabel name={"SelectPaymentMethod"} groupName={"Content.StaticLabels"} />
          </label>
          <FormGroup className="payment-options-group" style={{ marginBottom: 30 }}>
            {settings.paymentMethods.map((p) => {
              return (
                <React.Fragment key={p}>
                  <PaymentOptionButton
                    {...{
                      option: p,
                      selectedOption,
                      isInvoice: current.payMethod == "invoice",
                      selectOption: () => {
                        expand(p);
                        setSelectedOption(p);
                      },
                    }}
                  />
                </React.Fragment>
              );
            })}
          </FormGroup>
        </FormControl>
        {selectedOption == "invoice" || current.payMethod == "invoice" ? <InvoiceFields {...props} /> : null}
      </div>
    );
  }

  return null;
};

export default observer(PaymentOptions);

const PaymentOptionButton = ({ option, selectOption, selectedOption, isInvoice }) => {
  const selectedColor = "#2196f3";
  switch (option) {
    case "dibs":
      return (
        <div style={{ textAlign: "center", position: "relative" }}>
          {selectedOption == option ? (
            <div className="selected-margin-corner">
              <div className="border">
                <CheckCircleIcon style={{ color: selectedColor }} />
              </div>
            </div>
          ) : null}
          <div onClick={selectOption} className={"payment-button" + (selectedOption == option ? " selected" : "")}>
            <CreditCardIcon />
          </div>
          <FormHelperText style={{ textAlign: "center", display: "flex", justifyContent: "center", maxWidth: 100 }}>
            <EventLabel name={"CreditCard"} groupName={"Content.StaticLabels"} />
          </FormHelperText>
        </div>
      );
    case "invoice":
      return (
        <div style={{ textAlign: "center", position: "relative" }}>
          {selectedOption == option || isInvoice ? (
            <div className="selected-margin-corner">
              <div className="border">
                <CheckCircleIcon style={{ color: selectedColor }} />
              </div>
            </div>
          ) : null}
          <div onClick={selectOption} className={"payment-button" + (selectedOption == option ? " selected" : "")}>
            <ReceiptIcon />
          </div>
          <FormHelperText style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
            <EventLabel name={"Invoice"} groupName={"Content.StaticLabels"} />
          </FormHelperText>
        </div>
      );

    default:
      return null;
  }
};
